
import axios from "axios";
import authHeader from "./authHeader";
import { adminApi, api, baseUrl, configApi, host, tenant } from "./endpoints";

export const getDepartmentsTypeService = async () => {
    const res = await axios.get(host + baseUrl + tenant + configApi.config + configApi.departments, {
        headers: authHeader()
    });
    return res;
};

export const getTransactionsTypesListsService = async () => {
    const res = await axios.get(host + baseUrl + tenant + configApi.config + configApi.transactionTypes, {
        headers: authHeader()
    });
    return res;
};

export const getRolesService = async () => {
    const res = await axios.get(host + baseUrl + tenant + configApi.roles, {
        headers: authHeader()
    });
    return res;
};

export const getWorkflowConfigurationService = async () => {
    const res = await axios.get(host + baseUrl + tenant + configApi.workflow + configApi.config, {
        headers: authHeader()
    });
    return res;
};

export const getInquiryTypeService = async (data: Object) => {
    const res = await axios.post("",
        data, {
        headers: authHeader()
    });
    return res;
};

export const clearCacheService = async () => {
    const res = await axios.get(host + baseUrl + configApi.clearCache, {
        headers: authHeader()
    });
    return res;
};

export const getAssetsLogoService = async () => {
    const res = await axios.get(host + baseUrl + tenant + api.assets + api.logos, {
        headers: authHeader()
    });
    return res;
};

export const getAssetsImageService = async () => {
    const res = await axios.get(host + baseUrl + tenant + api.assets + api.images, {
        headers: authHeader()
    });
    return res;
};

export const getLogoService = async (name: string) => {
    const res = await axios.get(host + baseUrl + tenant + api.assets + api.logos + "/" + name, {
        headers: authHeader(),
        responseType: 'blob'
    });
    return res;
};

export const getPublicImageService = async (name: string) => {
    const res = await axios.get(host + baseUrl + tenant + api.assets + api.logos + "/" + name, {
        headers: authHeader(),
        responseType: 'blob'
    });
    return res;
};

export const getPermissionService = async () => {
    const res = await axios.get(host + baseUrl + tenant + adminApi.user + api.permissions, {
        headers: authHeader(),
    });
    return res;
};